export const domain_details = [
  {
    key: "1",
    CompanyName: "BrightWave Innovations",
    BillCycle: "30",
    PaymentMethod: "Credit Card",
    Email: "michael@example.com",
    AccountURL: "bwi.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "12 Sep 2024",
    ExpiringDate: "11 Oct 2024",
    Image: "company-01.svg",
    Status: "Paid",
    Amount: "$200",
    InvoiceID: "INV001",
    DomainStatus: "Approved",
  },
  {
    key: "2",
    CompanyName: "Stellar Dynamics",
    BillCycle: "365",
    PaymentMethod: "Paypal",
    Email: "sophie@example.com",
    AccountURL: "sd.example.com",
    Plan: "Basic (Yearly)",
    CreatedDate: "24 Oct 2024",
    ExpiringDate: "23 Nov 2025",
    Image: "company-02.svg",
    Status: "Paid",
    Amount: "$600",
    InvoiceID: "INV002",
    DomainStatus: "Pending",
  },
  {
    key: "3",
    CompanyName: "Quantum Nexus",
    BillCycle: "30",
    PaymentMethod: "Debit Card",
    Email: "cameron@example.com",
    AccountURL: "qn.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "18 Feb 2024",
    ExpiringDate: "17 Mar 2024",
    Image: "company-03.svg",
    Status: "Paid",
    Amount: "$200",
    InvoiceID: "INV003",
    DomainStatus: "Rejected",
  },
  {
    key: "4",
    CompanyName: "EcoVision Enterprises",
    BillCycle: "30",
    PaymentMethod: "Paypal",
    Email: "doris@example.com",
    AccountURL: "eve.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "17 Oct 2024",
    ExpiringDate: "16 Nov 2024",
    Image: "company-04.svg",
    Status: "Paid",
    Amount: "$200",
    InvoiceID: "INV004",
    DomainStatus: "Approved",
  },
  {
    key: "5",
    CompanyName: "Aurora Technologies",
    BillCycle: "30",
    PaymentMethod: "Credit Card",
    Email: "thomas@example.com",
    AccountURL: "at.example.com",
    Plan: "Enterprise (Monthly)",
    CreatedDate: "20 Jul 2024",
    ExpiringDate: "19 Aug 2024",
    Image: "company-05.svg",
    Status: "Paid",
    Amount: "$400",
    InvoiceID: "INV005",
    DomainStatus: "Approved",
  },
  {
    key: "6",
    CompanyName: "BlueSky Ventures",
    BillCycle: "30",
    PaymentMethod: "Paypal",
    Email: "kathleen@example.com",
    AccountURL: "bsv.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "10 Apr 2024",
    ExpiringDate: "09 May 2024",
    Image: "company-06.svg",
    Status: "Paid",
    Amount: "$200",
    InvoiceID: "INV006",
    DomainStatus: "Pending",
  },
  {
    key: "7",
    CompanyName: "TerraFusion Energy",
    BillCycle: "365",
    PaymentMethod: "Credit Card",
    Email: "bruce@example.com",
    AccountURL: "tfe.example.com",
    Plan: "Enterprise (Yearly)",
    CreatedDate: "29 Aug 2024",
    ExpiringDate: "28 Aug 2025",
    Image: "company-07.svg",
    Status: "Paid",
    Amount: "$4800",
    InvoiceID: "INV007",
    DomainStatus: "Approved",
  },
  {
    key: "8",
    CompanyName: "UrbanPulse Design",
    BillCycle: "30",
    PaymentMethod: "Credit Card",
    Email: "estelle@example.com",
    AccountURL: "upd.example.com",
    Plan: "Basic (Monthly)",
    CreatedDate: "22 Feb 2024",
    ExpiringDate: "21 Mar 2024",
    Image: "company-08.svg",
    Status: "Unpaid",
    Amount: "$50",
    InvoiceID: "INV008",
    DomainStatus: "Rejected",
  },
  {
    key: "9",
    CompanyName: "Nimbus Networks",
    BillCycle: "365",
    PaymentMethod: "Paypal",
    Email: "stephen@example.com",
    AccountURL: "nn.example.com",
    Plan: "Basic (Yearly)",
    CreatedDate: "03 Nov 2024",
    ExpiringDate: "02 Nov 2025",
    Image: "company-09.svg",
    Status: "Paid",
    Amount: "$600",
    InvoiceID: "INV009",
    DomainStatus: "Approved",
  },
  {
    key: "10",
    CompanyName: "Epicurean Delights",
    BillCycle: "30",
    PaymentMethod: "Credit Card",
    Email: "angela@example.com",
    AccountURL: "ed.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "17 Dec 2024",
    ExpiringDate: "16 Jan 2025",
    Image: "company-10.svg",
    Status: "Paid",
    Amount: "$200",
    InvoiceID: "INV010",
    DomainStatus: "Approved",
  },
];
